import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/tcDash.css";

// Header component represents the header section of the page
function DriverNav() {
  const authString = localStorage.getItem("user");
  const auth = authString ? JSON.parse(authString) : [];
  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div id="root">
      <nav class="navbar navbar-dark fixed-top">
        <div class="container-fluid ">
          <h2 className="text-light">
            <span>IN</span>FORCE
          </h2>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div class="offcanvas-header">
              <h5 class="offcanvas-title text-white" id="offcanvasNavbarLabel">
                Quick views
              </h5>
              <button
                type="button"
                class="btn-close bg-white rounded-circle"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav justify-content-end flex-grow-1 ">
                <li class="nav-item my-3">
                  <NavLink to="/driver/dashboard" className="links">
                    Home
                  </NavLink>
                </li>
                <li class="nav-item my-3">
                  <NavLink to="/case/view" className="links">
                    Case History
                  </NavLink>
                </li>

                <li class="nav-item my-3">
                  <NavLink className="links" to="/policestation">
                    Police Stations in Chattogram
                  </NavLink>
                </li>

                <li class="nav-item my-3">
                  <NavLink to="/laws" className="links">
                    Violations & Fines
                  </NavLink>
                </li>
              </ul>
              <form class="d-flex mt-3 position-relative" role="search">
                <NavLink
                  className="btn btn-outline-light w-100"
                  type="button"
                  id="form-open"
                  to="/"
                  onClick={logout}
                >
                  Logout ({auth[0].name})
                </NavLink>
              </form>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default DriverNav;
